
import * as d3 from 'd3';
import wrapper from 'wrapper';
import events from '../scrolly-library/events-emitter';
import data from '../../assets/data/locusts-chart';
import visualisationConfig from './visualisation-config';
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */

export default class Chart {
    constructor() {
        this.data = data;
        this.dataTypes = visualisationConfig.dataTypes;
        this.years = this.data.map((datum) => datum.year);

        this.chartWidth = wrapper.select('.chart').offsetWidth;
        this.chartHeight = wrapper.select('.chart').offsetHeight;
        this.graphMargin = visualisationConfig.graphMargins;
        this.graphWidth = this.chartWidth - this.graphMargin.left - this.graphMargin.right;
        this.graphHeight = this.chartHeight - wrapper.select('.chart-title-container').offsetHeight - wrapper.select('.chart-note-container').offsetHeight;
        this.scaleY = d3.scaleLinear().domain([2020, 1925]).range([0, this.graphHeight]);
        this.scaleX = d3.scaleLinear().domain([0, 50]).range([0, this.graphWidth]);
        this.breakpoint = visualisationConfig.breakpoint;

        this.chartOfLocusts();

        window.addEventListener('resize', () => {
            this.resizeGraph();
        });

        events.on('showChart', () => {
            this.resizeGraph();
            wrapper.select('.graph-container').style.visibility = 'visible';
        });
    }

    chartOfLocusts() {
        this.drawAxisGraph();
        this.addGraphLabel();
        this.dataTypes.forEach((section) => {
            this.drawBarChart(section);
        });
    }

    addGraphLabel() {
        const titleLocationX = this.graphMargin.left - 45;
        d3.select('.chart-container')
            .append('text')
            .attr('font-family', 'ReithSans')
            .attr('class', 'graph-y-axis')
            .text(`${__('chart_year')}`)
            .attr('y', this.graphMargin.top - 16)
            .attr('x', titleLocationX);
    }

    redrawAxis() {
        const chart = d3.select(wrapper.select('.graph-container'));
        chart
            .attr('width', this.chartWidth)
            .attr('height', this.chartHeight);

        chart.select('.x-axis')
            .attr('transform', `translate(${this.graphMargin.left},${this.graphMargin.top})`)
            .call(this.x);
        chart.select('.y-axis')
            .attr('transform', `translate(${this.graphMargin.left},${this.graphMargin.top})`)
            .call(this.y);
    }

    drawAxisGraph() {
        this.plotAxis = d3.select('.svg-container').append('svg')
            .attr('class', 'graph-container animated')
            .attr('width', this.chartWidth)
            .attr('height', this.chartHeight)
            .append('g')
            .attr('class', 'chart-container');

        // Create the scale
        this.x = d3.axisTop()
            .tickSize([-this.graphHeight])
            .scale(this.scaleX);
        // Create the scale

        this.y = d3.axisLeft()
            .ticks(this.years.length)
            .tickFormat((d, i) => (i % 10) ? '' : d) // eslint-disable-line
            .scale(this.scaleY);

        this.plotAxis
            .append('g')
            .attr('class', 'x-axis')
            .attr('font-family', 'ReithSans')
            .attr('transform', `translate(${this.graphMargin.left},${this.graphMargin.top})`)
            .call(this.x);

        // Draw the axis
        this.plotAxis
            .append('g')
            .attr('class', 'y-axis')
            .attr('font-family', 'ReithSans')
            .attr('transform', `translate(${this.graphMargin.left},${this.graphMargin.top})`)
            .call(this.y);
    }

    drawBarChart(section) {
        this.plotAxis.append('g').selectAll(`.${section}`)
            .data(this.data)
            .enter()
            .append('rect')
            .attr('class', `bar ${section}`);

        this.adjustBarAttributes(section);
    }

    adjustBarAttributes(section) {
        d3.selectAll(`.bar.${section}`)
            .attr('transform', `translate(${this.graphMargin.left},${this.graphMargin.top})`)
            .attr('fill', visualisationConfig.colorsBarChart[section])
            .attr('width', (d) => this.scaleX(d[section]))
            .attr('x', 0)
            .attr('y', (d) => this.scaleY(d.year))
            .attr('height', '5px');
    }

    resizeGraph() {
        const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        this.updateMargins(vw);
        this.chartWidth = wrapper.select('.chart').offsetWidth;
        this.chartHeight = wrapper.select('.chart').offsetHeight - wrapper.select('.chart-title-container').offsetHeight - wrapper.select('.chart-note-container').offsetHeight;
        wrapper.select('.vis-container').style.height = `${this.chartHeight}px`;
        this.graphWidth = this.chartWidth - this.graphMargin.left - this.graphMargin.right;
        this.graphHeight = this.chartHeight - this.graphMargin.top - this.graphMargin.bottom;
        this.scaleX.range([0, this.graphWidth]);
        this.scaleY.range([0, this.graphHeight]);
        this.redrawAxis();
        this.dataTypes.forEach((section) => {
            this.adjustBarAttributes(section);
        });
        d3.select('.graph-container').selectAll('.x-axis .tick text')
            .attr('y', -10);
        d3.select('.graph-y-axis')
            .attr('x', this.graphMargin.left - 45);
    }

    updateMargins(vw) {
        this.graphMargin.left = (vw <= this.breakpoint) ? 50 : 100;
        this.graphMargin.right = (vw <= this.breakpoint) ? 50 : 100;
    }
}
